/* istanbul ignore file */
import React from 'react';

function IconLinkedIn() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    className: "icon-linkedIn",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      width: 42
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle-1",
    fill: "#007ab9",
    cx: "16",
    cy: "16",
    r: "16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-1",
    fill: "#f1f2f2",
    d: "M25.6,17.3v6.6h-3.8v-6.2c0-1.5-0.6-2.6-1.9-2.6c-1.1,0-1.7,0.7-2,1.4c-0.1,0.2-0.1,0.6-0.1,0.9v6.4h-3.8\nc0,0,0.1-10.4,0-11.5h3.8V14c0,0,0,0,0,0h0v0c0.5-0.8,1.4-1.9,3.4-1.9C23.7,12.1,25.6,13.8,25.6,17.3L25.6,17.3z M9.9,6.8\nc-1.3,0-2.2,0.9-2.2,2c0,1.1,0.8,2,2.1,2h0c1.3,0,2.2-0.9,2.2-2C12,7.7,11.2,6.8,9.9,6.8L9.9,6.8z M7.9,23.9h3.8V12.4H7.9V23.9z"
  }));
}

export default IconLinkedIn;